var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAdminEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_278_546",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 17H1V16H17V17ZM11.6436 0C11.876 0 12.0993 0.0924987 12.2637 0.256836L14.7432 2.73633C14.9075 2.90071 15 3.124 15 3.35645C15 3.58877 14.9074 3.81124 14.7432 3.97559L4.71973 14H1V10.2803L11.0244 0.256836C11.1888 0.0926254 11.4112 3.40877e-05 11.6436 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 17H1V16H17V17ZM11.6436 0C11.876 0 12.0993 0.0924987 12.2637 0.256836L14.7432 2.73633C14.9075 2.90071 15 3.124 15 3.35645C15 3.58877 14.9074 3.81124 14.7432 3.97559L4.71973 14H1V10.2803L11.0244 0.256836C11.1888 0.0926254 11.4112 3.40877e-05 11.6436 0Z",
    fill: "url(#paint0_linear_278_546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17V17.5H17.5V17H17ZM1 17H0.5V17.5H1V17ZM1 16V15.5H0.5V16H1ZM17 16H17.5V15.5H17V16ZM11.6436 0V-0.5H11.6435L11.6436 0ZM12.2637 0.256836L12.6172 -0.0967175L12.6172 -0.0967708L12.2637 0.256836ZM14.7432 2.73633L15.0968 2.38283L15.0967 2.38277L14.7432 2.73633ZM15 3.35645L15.5 3.35652V3.35645H15ZM14.7432 3.97559L15.0967 4.32912L15.0969 4.329L14.7432 3.97559ZM4.71973 14V14.5H4.92685L5.0733 14.3535L4.71973 14ZM1 14H0.5V14.5H1V14ZM1 10.2803L0.646464 9.9267L0.5 10.0732V10.2803H1ZM11.0244 0.256836L10.671 -0.0968586L10.6709 -0.0967347L11.0244 0.256836ZM17 17V16.5H1V17V17.5H17V17ZM1 17H1.5V16H1H0.5V17H1ZM1 16V16.5H17V16V15.5H1V16ZM17 16H16.5V17H17H17.5V16H17ZM11.6436 0V0.5C11.7434 0.5 11.8395 0.53981 11.9102 0.610443L12.2637 0.256836L12.6172 -0.0967708C12.3591 -0.354813 12.0086 -0.5 11.6436 -0.5V0ZM12.2637 0.256836L11.9101 0.610389L14.3896 3.08988L14.7432 2.73633L15.0967 2.38277L12.6172 -0.0967175L12.2637 0.256836ZM14.7432 2.73633L14.3896 3.08983C14.4602 3.16048 14.5 3.25663 14.5 3.35645H15H15.5C15.5 2.99138 15.3548 2.64095 15.0968 2.38283L14.7432 2.73633ZM15 3.35645L14.5 3.35637C14.5 3.45549 14.4605 3.55108 14.3895 3.62217L14.7432 3.97559L15.0969 4.329C15.3542 4.07141 15.4999 3.72205 15.5 3.35652L15 3.35645ZM14.7432 3.97559L14.3896 3.62205L4.36616 13.6465L4.71973 14L5.0733 14.3535L15.0967 4.32912L14.7432 3.97559ZM4.71973 14V13.5H1V14V14.5H4.71973V14ZM1 14H1.5V10.2803H1H0.5V14H1ZM1 10.2803L1.35354 10.6338L11.378 0.610407L11.0244 0.256836L10.6709 -0.0967347L0.646464 9.9267L1 10.2803ZM11.0244 0.256836L11.3778 0.61053C11.4489 0.539496 11.5445 0.500015 11.6436 0.5L11.6436 0L11.6435 -0.5C11.278 -0.499946 10.9286 -0.354245 10.671 -0.0968586L11.0244 0.256836Z",
    fill: "url(#paint1_linear_278_546)",
    mask: "url(#path-1-inside-1_278_546)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_546",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_278_546",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminEdit);
export default __webpack_public_path__ + "static/media/ic-admin-edit.9071b6594a773620f2d32cecda01f2f4.svg";
export { ForwardRef as ReactComponent };